import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import TokenInput from './components/TokenInput';
import RsvpForm from './components/RsvpForm/RsvpForm';
import WeddingInfo from './components/WeddingInfo';
import FAQ from './components/FAQ';
import LanguageSwitcher from './components/LanguageSwitcher';
import { getGuest, Guest } from './services/api';

function App() {
  const [token, setToken] = useState<string>('');
  const [guest, setGuest] = useState<Guest | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const { t, i18n } = useTranslation();

  // Check for token in URL hash or localStorage
  useEffect(() => {
    // Get token from URL hash (anchor tag)
    const hashToken = window.location.hash.substring(1); // Remove the # character
    const storedToken = localStorage.getItem('weddingToken');

    if (hashToken) {
      setToken(hashToken);
      fetchGuest(hashToken);

      // Optionally clear the hash from URL after reading
      // window.location.hash = '';
    } else if (storedToken) {
      setToken(storedToken);
      fetchGuest(storedToken);
    }
  }, []);

  // Update language based on guest preference
  useEffect(() => {
    if (guest && guest.language) {
      i18n.changeLanguage(guest.language);
    }
  }, [guest, i18n]);

  const fetchGuest = async (guestToken: string): Promise<void> => {
    setLoading(true);
    setError('');
    try {
      const guestData = await getGuest(guestToken);
      setGuest(guestData);
      localStorage.setItem('weddingToken', guestToken);
      setToken(guestToken);
    } catch (err) {
      console.error('Error fetching guest:', err);
      setError(t('invalidToken'));
    } finally {
      setLoading(false);
    }
  };

  const handleTokenSubmit = (submittedToken: string): void => {
    setToken(submittedToken);
    fetchGuest(submittedToken);

    // Update URL hash with token for sharing
    window.location.hash = submittedToken;
  };

  return (
    <div className="App">
      <div className="header-card">
        <header className="App-header">
          <LanguageSwitcher />
          <div className="header-content">
            <h1>ZOE & CHRISTIAN</h1>
            <h2>{t('ceremonyDate')}</h2>
          </div>
        </header>
      </div>
      <main>
        {loading ? (
          <div className="loading">Loading...</div>
        ) : error ? (
          <div className="error-container">
            <p className="error">{error}</p>
            <TokenInput onTokenSubmit={handleTokenSubmit} />
          </div>
        ) : guest ? (
          <>
            <WeddingInfo />
            <RsvpForm token={token} guest={guest} />
            <FAQ />
          </>
        ) : (
          <TokenInput onTokenSubmit={handleTokenSubmit} />
        )}
      </main>
      <div className="footer-card">
        <div className="footer-card-image"></div>
        <footer>
          <p>© {new Date().getFullYear()} Zoe & Christian</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
